export default __webpack_public_path__ + "static/media/orange-clock.32564dd9.svg";